/**
 * GenesysCommServiceGateway
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PlaceOutbountCallRequest { 
    syStudentId?: number | null;
    phoneNumber: string;
    conversationId?: string | null;
    isLocalTouch: boolean;
    syStudentInquiryId: number;
    dialerContactId: number;
    accountId: number;
    telecomInteractionType: PlaceOutbountCallRequest.TelecomInteractionTypeEnum;
    participantId?: string | null;
}
export namespace PlaceOutbountCallRequest {    
    export type TelecomInteractionTypeEnum = 'Callback' | 'DialerCall' | 'IncomingCall' | 'OutgoingCall';
    export const TelecomInteractionTypeEnum = {       
        NUMBER_null: 'Callback' as TelecomInteractionTypeEnum,
        NUMBER_null2: 'DialerCall' as TelecomInteractionTypeEnum,
        NUMBER_null3: 'IncomingCall' as TelecomInteractionTypeEnum,
        NUMBER_null4: 'OutgoingCall' as TelecomInteractionTypeEnum
    };
}


